import { Box, Slider, Typography } from "@mui/material";
import { palette } from "../../themes/theme";

const HaloEffectRange = ({
  title,
  value,
  onChange,
  type,
  min,
  max,
  disabled,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 3,
      }}
    >
      <Typography
        sx={{
          color: palette.text.dark,
          fontWeight: "bold",
          fontSize: 20,
        }}
      >
        {title}
      </Typography>
      <Slider
        min={min}
        step={1}
        max={max}
        defaultValue={Number(value || 0)}
        // onChange={onChange}
        onChangeCommitted={(_, value) => onChange(type, value)}
        valueLabelDisplay="auto"
        sx={{ width: "65%", color: palette.primary.main }}
        disabled={disabled}
      />
    </Box>
  );
};

export default HaloEffectRange;
